// src/Components/UsuarioForm/UsuarioForm.jsx

import React, { useState } from 'react';
import { Link } from 'react-router-dom';

// Helper para gerar os checkboxes de permissão
const PermissaoGroup = ({ entidade, titulo, state, handleChange }) => (
    <div className="permissao-grupo mb-4 p-3 border rounded bg-light">
        <h6 className="permissao-titulo mb-3 fw-bold text-dark">{titulo}</h6>
        <div className="d-flex flex-wrap gap-4">
            <div className="form-check">
                <input className="form-check-input form-check-input-custom" type="checkbox" id={`ler_${entidade}`} name={`ler_${entidade}`} checked={state[`ler_${entidade}`]} onChange={handleChange} />
                <label className="form-check-label ms-2" htmlFor={`ler_${entidade}`}>Leitura</label>
            </div>
            <div className="form-check">
                <input className="form-check-input form-check-input-custom" type="checkbox" id={`cadastrar_${entidade}`} name={`cadastrar_${entidade}`} checked={state[`cadastrar_${entidade}`]} onChange={handleChange} />
                <label className="form-check-label ms-2" htmlFor={`cadastrar_${entidade}`}>Cadastro</label>
            </div>
            <div className="form-check">
                <input className="form-check-input form-check-input-custom" type="checkbox" id={`editar_${entidade}`} name={`editar_${entidade}`} checked={state[`editar_${entidade}`]} onChange={handleChange} />
                <label className="form-check-label ms-2" htmlFor={`editar_${entidade}`}>Edição</label>
            </div>
            <div className="form-check">
                <input className="form-check-input form-check-input-custom" type="checkbox" id={`excluir_${entidade}`} name={`excluir_${entidade}`} checked={state[`excluir_${entidade}`]} onChange={handleChange} />
                <label className="form-check-label ms-2" htmlFor={`excluir_${entidade}`}>Exclusão</label>
            </div>

            {/* Custom Financial Permissions */}
            {(entidade === 'financeiro_a_receber' || entidade === 'financeiro_a_pagar') && (
                <>
                    <div className="form-check">
                        <input className="form-check-input form-check-input-custom" type="checkbox" id={`pagar_${entidade}`} name={`pagar_${entidade}`} checked={state[`pagar_${entidade}`]} onChange={handleChange} />
                        <label className="form-check-label ms-2" htmlFor={`pagar_${entidade}`}>Efetuar Pagamento</label>
                    </div>
                    <div className="form-check">
                        <input className="form-check-input form-check-input-custom" type="checkbox" id={`estornar_${entidade}`} name={`estornar_${entidade}`} checked={state[`estornar_${entidade}`]} onChange={handleChange} />
                        <label className="form-check-label ms-2" htmlFor={`estornar_${entidade}`}>Estornar</label>
                    </div>
                </>
            )}
        </div>
    </div>
);


function UsuarioForm({ initialData = {}, onSubmit, isEditing = false, loading = false }) {

    // Define o estado inicial pegando de initialData ou definindo como falso
    const getInitialState = () => {
        const permissoesBase = {
            ler_usuarios: false, cadastrar_usuarios: false, editar_usuarios: false, excluir_usuarios: false,
            ler_empresas: false, cadastrar_empresas: false, editar_empresas: false, excluir_empresas: false,
            ler_marcas: false, cadastrar_marcas: false, editar_marcas: false, excluir_marcas: false,
            ler_grades: false, cadastrar_grades: false, editar_grades: false, excluir_grades: false,
            ler_unidades_medida: false, cadastrar_unidades_medida: false, editar_unidades_medida: false, excluir_unidades_medida: false,
            ler_etapas_producao: false, cadastrar_etapas_producao: false, editar_etapas_producao: false, excluir_etapas_producao: false,
            ler_insumos: false, cadastrar_insumos: false, editar_insumos: false, excluir_insumos: false,
            ler_produtos: false, cadastrar_produtos: false, editar_produtos: false, excluir_produtos: false,
            ler_movimentacoes: false, cadastrar_movimentacoes: false, editar_movimentacoes: false, excluir_movimentacoes: false,
            ler_pedidos: false, cadastrar_pedidos: false, editar_pedidos: false, excluir_pedidos: false,
            ler_producao: false, cadastrar_producao: false, editar_producao: false, excluir_producao: false,

            ler_financeiro_a_receber: false, cadastrar_financeiro_a_receber: false, editar_financeiro_a_receber: false, excluir_financeiro_a_receber: false, pagar_financeiro_a_receber: false, estornar_financeiro_a_receber: false,
            ler_financeiro_a_pagar: false, cadastrar_financeiro_a_pagar: false, editar_financeiro_a_pagar: false, excluir_financeiro_a_pagar: false, pagar_financeiro_a_pagar: false, estornar_financeiro_a_pagar: false,
            // Outras Permissões
            ler_dashboard: false,
            ler_configuracoes: false,
            ler_minhaconta: false,
        };

        // Sobrepõe a base com os dados iniciais, se existirem
        for (const key in permissoesBase) {
            if (initialData[key] !== undefined) {
                permissoesBase[key] = !!initialData[key];
            }
        }

        return {
            nome: initialData.nome || '',
            email: initialData.email || '',

            senha: '',
            confirmaSenha: '',
            ...permissoesBase,
        };
    };

    const [formData, setFormData] = useState(getInitialState());

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));
    };

    const handleSelectAll = () => {
        setFormData(prev => {
            const newState = { ...prev };
            Object.keys(newState).forEach(key => {
                if (key.startsWith('ler_') ||
                    key.startsWith('cadastrar_') ||
                    key.startsWith('editar_') ||
                    key.startsWith('excluir_') ||
                    key.startsWith('pagar_') ||
                    key.startsWith('estornar_')) {
                    newState[key] = true;
                }
            });
            return newState;
        });
    };

    const handleSubmit = (event) => {
        event.preventDefault();

        if (!isEditing && formData.senha !== formData.confirmaSenha) {
            alert('A senha e a confirmação de senha não são iguais.');
            return;
        }

        // Prepara os dados para enviar (exclui confirmação de senha)
        const { confirmaSenha, ...dataToSend } = formData;

        // Se estiver editando, não envia a senha
        if (isEditing) {
            delete dataToSend.senha;
        }

        onSubmit(dataToSend);
    };

    return (
        <>
            <form onSubmit={handleSubmit} className="mb-2"> {/* mb-5 para dar espaço para a barra fixa */}
                <div className="row g-4">
                    <div className="col-12">
                        <div className="form-card">
                            <h2 className="form-section-header">Dados Básicos</h2>

                            <div className="row g-3">

                                <div className="col-md-10">
                                    <label htmlFor="nome" className="form-label-custom required-field">Nome Completo</label>
                                    <input type="text" className="form-control-custom" id="nome" name="nome" value={formData.nome} onChange={handleChange} required />
                                </div>

                                <div className="col-md-12">
                                    <label htmlFor="email" className="form-label-custom required-field">E-mail (Login)</label>
                                    <input type="email" className="form-control-custom" id="email" name="email" value={formData.email} onChange={handleChange} required disabled={isEditing} />
                                    {isEditing && <div className="form-text text-muted small mt-1">O e-mail de login não pode ser alterado.</div>}
                                </div>

                                {!isEditing && (
                                    <>
                                        <div className="col-md-6">
                                            <label htmlFor="senha" className="form-label-custom required-field">Senha</label>
                                            <input type="password" placeholder="Mínimo 6 caracteres" className="form-control-custom" id="senha" name="senha" value={formData.senha} onChange={handleChange} required />
                                        </div>
                                        <div className="col-md-6">
                                            <label htmlFor="confirmaSenha" className="form-label-custom required-field">Confirmação de Senha</label>
                                            <input type="password" placeholder="Repita a senha" className="form-control-custom" id="confirmaSenha" name="confirmaSenha" value={formData.confirmaSenha} onChange={handleChange} required />
                                        </div>
                                    </>
                                )}
                            </div>
                        </div>
                    </div>

                    <div className="col-12">
                        <div className="form-card">
                            <h2 className="form-section-header">Permissões de Acesso</h2>
                            <div className="row">
                                <div className="col-12 mb-3">
                                    <button
                                        type="button"
                                        className="btn btn-outline-primary btn-sm"
                                        onClick={handleSelectAll}
                                    >
                                        <i className="fas fa-check-double me-2"></i>
                                        Marcar todas as permissões
                                    </button>
                                </div>
                                <div className="col-12">
                                    <PermissaoGroup entidade="usuarios" titulo="Usuários" state={formData} handleChange={handleChange} />
                                    <PermissaoGroup entidade="empresas" titulo="Empresas (Clientes, Fornecedores, etc.)" state={formData} handleChange={handleChange} />
                                    <PermissaoGroup entidade="produtos" titulo="Produtos" state={formData} handleChange={handleChange} />
                                    <PermissaoGroup entidade="insumos" titulo="Insumos" state={formData} handleChange={handleChange} />
                                    <PermissaoGroup entidade="pedidos" titulo="Pedidos de Venda" state={formData} handleChange={handleChange} />
                                    <PermissaoGroup entidade="producao" titulo="Produção" state={formData} handleChange={handleChange} />
                                    <PermissaoGroup entidade="financeiro_a_receber" titulo="Financeiro a Receber" state={formData} handleChange={handleChange} />
                                    <PermissaoGroup entidade="financeiro_a_pagar" titulo="Financeiro a Pagar" state={formData} handleChange={handleChange} />
                                    <PermissaoGroup entidade="movimentacoes" titulo="Movimentações de Estoque" state={formData} handleChange={handleChange} />
                                    <PermissaoGroup entidade="marcas" titulo="Marcas" state={formData} handleChange={handleChange} />
                                    <PermissaoGroup entidade="grades" titulo="Grades" state={formData} handleChange={handleChange} />
                                    <PermissaoGroup entidade="unidades_medida" titulo="Unidades de Medida" state={formData} handleChange={handleChange} />
                                    <PermissaoGroup entidade="etapas_producao" titulo="Etapas de Produção" state={formData} handleChange={handleChange} />
                                </div>
                                <div className="col-12 mt-4">
                                    <div className="permissao-grupo mb-4 p-3 border rounded bg-light">
                                        <h6 className="permissao-titulo mb-3 fw-bold text-dark">Outras Permissões</h6>
                                        <div className="d-flex flex-wrap gap-4">
                                            <div className="form-check">
                                                <input className="form-check-input form-check-input-custom" type="checkbox" id="ler_dashboard" name="ler_dashboard" checked={formData.ler_dashboard} onChange={handleChange} />
                                                <label className="form-check-label ms-2" htmlFor="ler_dashboard">Visualizar Dashboard</label>
                                            </div>
                                            <div className="form-check">
                                                <input className="form-check-input form-check-input-custom" type="checkbox" id="ler_configuracoes" name="ler_configuracoes" checked={formData.ler_configuracoes} onChange={handleChange} />
                                                <label className="form-check-label ms-2" htmlFor="ler_configuracoes">Acessar Configurações</label>
                                            </div>
                                            <div className="form-check">
                                                <input className="form-check-input form-check-input-custom" type="checkbox" id="ler_minhaconta" name="ler_minhaconta" checked={formData.ler_minhaconta} onChange={handleChange} />
                                                <label className="form-check-label ms-2" htmlFor="ler_minhaconta">Acessar Minha Conta</label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Fixed Action Bar */}
                <div className="form-actions-bar">
                    <div className="container-fluid d-flex justify-content-end gap-3 align-items-center">
                        <Link to='/app/usuarios' className="btn btn-secondary-custom">
                            Cancelar
                        </Link>
                        <button type="submit" className="btn btn-primary-custom" disabled={loading}>
                            {loading ? (
                                <>
                                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                    {isEditing ? 'Atualizando...' : 'Salvando...'}
                                </>
                            ) : (
                                isEditing ? 'Atualizar Usuário' : 'Salvar Usuário'
                            )}
                        </button>
                    </div>
                </div>
            </form>
        </>
    );
}
export default UsuarioForm;